export default __webpack_public_path__ + "static/media/signature_light.c39d9a3e.png";